import { FC, useMemo } from 'react';

import { Link, Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';
import { useDashboardRoute } from 'hooks/useDashboardRoute';

import styles from 'pages/AdCopyPage/AdCopyPage.module.less';

import { PageContentHeader } from 'components/common/PageContentHeader/PageContentHeader';
import { VacancyLink } from 'components/common/VacancyLink/VacancyLink';
import { CpcFlexibleCreate } from 'components/CpcFlexibleCreate/CpcFlexibleCreate';
import { useCpcFlexibleCreateData } from 'components/CpcFlexibleCreate/useCpcFlexibleCreateData';
import { Header } from 'components/Header/Header';

import { useSelector } from 'store/utils';

const TrlKeys = {
    dashboard: 'AdCreatePage.breadcrumbs.dashboard',
    copy: 'AdCreatePage.breadcrumbs.copy',
};

export const AdCopyPage: FC = () => {
    const { bannerVacancyId, bannerLink, vacancyName } = useSelector((state) => state.createBanner);

    const { titleText } = useCpcFlexibleCreateData();
    const trls = useTrls();
    const dashboardRoute = useDashboardRoute();

    let additionalContent = null;
    if (bannerLink && bannerVacancyId) {
        additionalContent = (
            <VacancyLink dataQa="header-vacancy-link" vacancyId={bannerVacancyId} vacancyName={vacancyName} />
        );
    } else if (bannerLink) {
        additionalContent = (
            <Link href={bannerLink} target="_blank" data-qa="header-banner-link" overflowWrap="anywhere">
                <Text maxLines={1}>{bannerLink}</Text>
            </Link>
        );
    }

    const breadcrumbs = useMemo(
        () => [
            {
                to: dashboardRoute,
                children: trls(TrlKeys.dashboard),
            },
            { to: '#', children: trls(TrlKeys.copy) },
        ],
        [dashboardRoute, trls]
    );

    return (
        <div className={styles.wrapper}>
            <Header />
            <PageContentHeader
                breadcrumbsConfig={breadcrumbs}
                title={trls(titleText)}
                additionalContent={additionalContent}
                vSpacingBottom={24}
            />
            <CpcFlexibleCreate />
        </div>
    );
};
